export default __webpack_public_path__ + "static/media/navicon.657bed64.svg";